import { render } from "./Tickets.vue?vue&type=template&id=523e4644"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"
script.render = render

export default script